/**
 * WordPress dependencies
 */
import { useMemo } from '@wordpress/element';

/**
 * Internal dependencies
 */

import { DataFormProvider } from '../dataform-context';
import { normalizeFields } from '../../normalize-fields';
import { DataFormLayout } from '../../dataforms-layouts/data-form-layout';
import { jsx as _jsx } from "react/jsx-runtime";
export default function DataForm({
  data,
  form,
  fields,
  onChange
}) {
  const normalizedFields = useMemo(() => normalizeFields(fields), [fields]);
  if (!form.fields) {
    return null;
  }
  return /*#__PURE__*/_jsx(DataFormProvider, {
    fields: normalizedFields,
    children: /*#__PURE__*/_jsx(DataFormLayout, {
      data: data,
      form: form,
      onChange: onChange
    })
  });
}
//# sourceMappingURL=index.js.map